import { CheckoutRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/checkout')({
  component: CheckoutRoute,
});
